
// cn.js
export default {
  home: {
    tab1: '首页',
    tab2: '服务',
    tab3: '定价',
    lang: 'English',
    lang1: 'EN',
    login: '登录',
    signup: '注册',
    banner1: '为您提供',
    banner2: '最专业',
    banner3: '的服务',
    banner4: '数据采集解决方案',
    bannerBtn: '进入仪表板',
    bannerTitle1: '专业的全球住宅代理',
    bannerSubtitle1: '超过',
    bannerSubtitle1_1: '60,000,000+',
    bannerSubtitle1_2: 'IP',
    bannerTitle2: '精确定位全球主要城市',
    bannerSubtitle2: '满足',
    bannerSubtitle2_1: '爬虫、电商',
    bannerSubtitle2_2: '等业务需求',
    bannerTitle3: '动态和静态随意切换',
    bannerSubtitle3: '支持',
    bannerSubtitle3_1: 'http、https、socks5',
    bannerSubtitle3_2: '易于使用',
    sTitle: '为您的业务提供可靠的数据获取解决方案',
    sTitle1: '住宅代理',
    sSubtitle1: '提取无阻断的真实住宅IP',
    sSubtitle1_1: '',
    st1_1: '高成功率',
    st1_2: '城市级别定位',
    st1_3: '全天支持',
    sTitle2: '领先技术',
    sSubtitle2: '基于AI和ML的有效信息捕获解决方案',
    st2_1: '无带宽或浏览限制',
    st2_2: '与各种浏览器和工具兼容',
    st2_3: '高性能代理架构',
    sTitle3: '实时爬虫',
    sSubtitle3: '从搜索引擎和电商网站提取数据',
    st3_1: '100% 成功率',
    st3_2: '国家/地区和ASN过滤',
    st3_3: '自适应解析器',
    gTitle: 'MIYAIP在全球200多个国家提供服务',
    gName1: '亚洲',
    gCountries1: '48个国家',
    gName2: '欧洲',
    gCountries2: '44个国家',
    gName3: '非洲',
    gCountries3: '54个国家',
    gName4: '大洋洲',
    gCountries4: '16个国家',
    gName5: '北美洲',
    gCountries5: '23个国家',
    gName6: '南美洲',
    gCountries6: '12个国家',
    pTitle: '更优惠的价格',
    pTitle1: '动态住宅',
    pSubtitile1: '定位',
    pSubtitile1_1: '国家',
    pDescribe1: '按数据计费，IP数量不限',
    pType1: '流量',
    pUnit1: '/G',
    pSubtitile2: '定位',
    pSubtitile2_1: '城市',    
    pTitle3: '静态住宅',
    pSubtitile3: '1个IP/月',
    pSubtitile3_1: '/独享',
    pDescribe3: '无限数据，按IP数量计费',
    pType3: 'IP',
    pUnit3: '/IP',    
    pSubtitile4: '1个IP/月',
    pSubtitile4_1: '/共享2用户',
    pBtnBuy: '立即购买',
    pPayType: '我们接受',
    pContact: '请联系我们了解更多特别套餐',
    pBtn: '免费试用',
    cTitle: '我们被选择的原因',
    cSubtitle: '500多个国家和地区的IP，速度更快，最佳服务器，为您提供更好的服务',
    cs1: '更快的速度',
    cs2: '更稳定的服务',
    cs3: '独家代理',
    cs4: '快速集成',
    goBtn: '去获取解决方案',
    lTel: '电话',
    lEmail: '邮箱',
    lTime: '在线时间',
    lAddress: '办公地址',
    lPolicy: '服务政策',
    lmiyaPolicy: 'Miya客户政策',
    lLink: '友情链接',
    lTip: 'MIYAIP仅为正式商业目的提供IP服务，用户使用MIYAIP进行的任何行为都不代表MIYAIP的意愿和观点。严禁用户利用MIYAIP从事任何违法犯罪行为。该产品不提供翻墙服务，由此产生的相关责任由用户承担，MIYAIP对此不承担任何法律责任。',
    lRights: 'BARNETWORK INC © 2023 保留所有权利',
    noData: '暂无数据',
    WeChat: '微信',
    Telegram: 'Telegram',
  },
  menu: {
    m1: '仪表板',
    m2: '动态住宅',
    m2_1: '代理生成-国家',
    m2_2: '代理生成-城市',
    m2_3: '购买流量',
    m3: '静态住宅',
    m3_1: '购买代理',
    m3_2: '已购明细',
    m4: '历史订单',
    m5: '帮助中心',
    m5_1: '帮助文档',
    m5_2: '服务条款',
    m6: '开发者API',
    m7: '奖励推广',
    backHome: '返回首页',
  },
  dashboard: {
    title1: '仪表板-动态住宅代理',
    dataName1: '总流量 [Gb]',
    dataName2: '已使用流量 [Gb]',
    dataName3: '剩余流量 [Gb]',
    subtitle1: '流量使用趋势',
    subtitle2: '已购静态住宅明细',
    title2: '仪表板-静态住宅代理',
    buyBtn: '购买流量',
    titleCountry: '定位国家',
    titleCity: '定位城市',
    proxyBtn: '代理生成',
    more: '更多',
    s5qr: 'Socks5 二维码',
    expirationTime: '过期时间',
    typeString: '类型', 
    total1: '全部代理',
    total2: '独享代理 ',
    total3: '共享代理',
    orders: '个',
  },
  login: {
    thank: '感谢选择Miya',
    title1: '用户登录',
    email: '邮箱地址',
    password: '密码',
    checkedText: '登录即同意我们的',
    checkedText1: '服务条款',
    login: '登录',
    noAccount: '还没有账号？',
    signup: '注册',
    forgetPassword: '忘记密码',
    errorEmail: '请输入正确的邮箱',
    errorPassword: '请输入密码',
    title2: '用户注册',
    emailCode: '邮箱验证码',
    sendCode: '发送验证码',
    codeTip: '如果没有收到验证码，请检查邮箱的垃圾箱',
    repeatPassword: '重复密码',
    inviteCode: '邀请码',
    checkedText2: '注册即代表同意',
    account: '已有账号？',
    title3: '重置密码',
    btnOK: '确认',
    repeatPassword1: '两次输入密码不一致!',
    placeholder1: '请输入邮箱',
    placeholder2: '请输入验证码',
    placeholder3: '请输入',
    placeholder4: '请输入邀请码（可留空）',
    error1: '请阅读并同意服务条款',
    error2: '账号或密码错误，登录失败！',
    editPassword: '修改密码',
    balance: '账户余额',
    recharge: 'USDT充值',
    recharge1: '充值',
    logout: '退出登录',
    success: '操作成功',
    rechargeType: '充值类型',
    rechargeCode: '付款地址',
    hash: '交易流水号',
    rechargeTip: 'USDT交易需要确认时间，请转账后等待10-20分钟后提交单号充值',
    hashTip: '充值后填写交易流水号，网站会显示您充值的USDT余额',
    rechargeInput: '请输入流水交易号',
    qrCodeText: '付款地址二维码',
    errorLogin: '请先登录系统',
    commit: '提交',
    balance1: 'USDT余额不足',
    agree: '同意',
    close1: '点此区域关闭',
  },
  pCountry: {
    title1: '动态住宅代理生成-定位国家',
    network: '代理网络',
    country: '国家',
    type: '池类型',
    time: 'IP固定切换时间',
    generationType: '生成类型',
    num: '数量',
    networkTip: '代理网络提示文字',
    countryTip: '国家提示文字',
    typeTip: '不同ip池内的ip效果略有不同',
    timeTip: 'ip自动切换的周期',
    generationTypeTip: '生成类型提示文字',
    numTip: '数量提示文字',
    selectPlaceholder: '请选择',
    inputPlaceholder: '请输入',
    api: 'API切换代理按钮',
    apiText: '如有必要，请单击',
    apiTip: '适合手动API切换IP的客户',
    copy: '复制',
    btnGeneration: '生成',
    exportApi: '导出成API',
    btnQrcode: '生成二维码',
    qrPlaceholder: '输入或粘贴代理文本生成二维码（一次只能将一条代理文本转为二维码）',
    emptyQr: '暂无二维码',
    qrcodeError: '代理文本格式错误',
    socks5Name: '生成socks5二维码（可用Shadowrocket直接扫码使用）',
  },
  pCity: {
    title1: '动态住宅代理生成-定位城市',
    countryCity: '国家-生成位置-城市',
    countryCityTip: '选择你需要位置的ip',
    placeholderCountryCity: '请选择国家-生成位置-城市',
    position: '服务器位置',
    positionTip: '选择距离你的本地网络最近的服务器地区，体验更快的代理速度',
    state: '州',
    city: '城市',
    placeholderCity1: '请选择国家',
    placeholderCity2: '请选择生成位置',
    placeholderCity3: '请选择城市',
  },
  pTraffic: {
    title1: '动态住宅-购买流量',
    name1: '类别',
    name2: '单价',
    name3: '时长',
    name4: 'IP池',
    name5: '动态IP池数量',
    name6: '并发性',
    name7: '时效可变性',
    name8: '城市定位',
    name9: '流量',
    option1: '永不过期',
    option2: '专属IP池',
    option3: '2个超大IP池，合计IP数量超6000万',
    option4: '无限并发',
    option5: '可变时效',
    option6: '不支持',
    option21: '永不过期',
    option22: '专属IP池',
    option23: '2个超大IP池，合计IP数量超6000万',
    option24: '无限并发',
    option25: '可变时效',
    option26: '支持',
    max100: '最大100G',
    btnLearn: '前去了解',
    buyIt: '买它',
    selectStr: '已选择定位',
    pTraffic: '购买流量',
    discountCode: '折扣码',
    placeholderDc: '请输入折扣码',
    amount: '总金额',
    btnUsdt: 'USDT余额',
    otherPay: '其它支付方式',
    contactTitle: '联系我们',
    Alipay: '支付宝',
    WeChat: '微信',
    payUSDT: 'USDT余额支付',
    payOk: '确认支付',
    payCancel: '取消',
    payCode: '付款码',
    paid: '已支付',
    selectType: '请选择类别',
    discountCodeError: '折扣码无效',
    commingSoon: '联系客服开通',
    loading: '订单正在加载中，请稍等...',
    noSelect: '未选择流量类别',
    dollar: '美元',
  },
  pAgent: {
    title1: '静态住宅-购买代理',
    country: '需求国家',
    countryTip: '需求国家Tip',
    ipType: 'IP授权类型',
    ipTypeTip: '(共享类型：1个IP共享2名用户)',
    price1: '独享单价',
    price2: '共享单价',
    priceUnit: '/IP/月',
    ipTime: 'IP购买时长',
    ipTimeTip: 'IP购买时长Tip',
    day: '天',
    year: '年',
    ipNumber: 'IP购买数量',
    maxIPNum: '（最大数量100）',
    type1: '独享',
    type2: '共享',
    select: '已选择',
    title2: '静态住宅-已购明细',
    all: '全部',
    operation: '操作',
    btnRenew: '续费',
    btnDel: '删除',
    unit: '条',
    mutRenew: '一键续费',
    mutDel: '一键删除',
    mutCancel: '取消选择',
    btnExport: '导出表格',
    htitl1: '全部 [订单]',
    htitl2: '未支付 [订单]',
    htitl3: '已支付 [订单]',
    htype1: '未支付',
    htype2: '已支付',
    htname1: '订单ID',
    htname2: '订单名称',
    htname3: '数量',
    htname4: '订单状态',
    htname5: '订购时间',
    htname6: '支付时间',
    renewIP: 'IP续费数量',
    renewTime: 'IP续费时长',
    placeholderSearch: '请输入ip查询',
    placeholderSearch1: '请输入id查询',
    deleteDialogTitle: '确认删除？',
    deleteDialogText: '删除后无法恢复',
    t1:'原始IP（Socks5）',
    t2:'原始IP（http）',
    t3:'中转代理（Socks5）',
    t4:'中转代理（http）',
  },
  reward: {
    cardName: '返利余额',
    tipText: '满20U提现',
    btn1: '提现',
    btn2: '全部转到USDT余额',
    title2: '邀请功能',
    subtitle2: '当您邀请朋友注册时',
    text1: '您将获取对方',
    text2: '每次',
    text3: '充值金额的',
    text4: '10%',
    text5: '返利，返利可用于提现或者直接购买产品',
    copyBtn1: '复制邀请码',
    copyBtn2: '复制邀请链接',
    placeholder2: '邀请链接',
    text6: '如您注册时使用了您名下其他账号的邀请链接，我们有权将邀请账号与购买账号一并封号处理(没有解封的可能)',
    title3: '返利记录',
    text7: '邀请用户给您带来的返利记录',
    tTitle1: 'ID',
    tTitle2: '被邀ID',
    tTitle3: '获得返利',
    tTitle4: '获得时间',
    copySuccess: '复制成功',
    copyError: '复制失败',
  },
  tos: {
    t1: "隐私政策",
    c11: "在MiyaIP，我们从事数据业务，正是因为如此，我们才如此重视数据隐私。我们的客户委托我们为他们的企业提供干净、合规和符合道德的数据，同时保留最高标准的隐私。我们的产品和服务在全球范围内运营，因此我们不断监控动态的全球隐私环境，并进行相应调整，以确保完全遵守隐私法。",
    c12: "本隐私政策既适用于积极选择使用我们服务的用户，如下文所述，也适用于我们可能在运营过程中处理其个人数据的个人。请随时阅读我们隐私政策的详细分类，或就我们的政策或数据立法合规性提出任何问题与我们联系。",
    c13: `MiyaIP（“MiyaIP”、“我们”或“我们”）是网站miyaip.com/（“网站”）以及我们提供的任何附带服务、功能、内容和应用程序（统称为“服务”）的所有者。我们关注您的隐私，设计本隐私政策是为了帮助您决定是否使用服务，并提供有关我们隐私做法的所有必要信息。如果适用于您，通过访问和使用服务，或以其他格式向我们提供信息，您同意并接受本隐私政策中不时修订的条款，并同意以本隐私政策规定的方式收集和使用信息。我们鼓励您仔细审查本隐私政策，并定期参考，以便您理解它以及对它所做的任何后续更改。`,
    t2: `我们收集什么类型的信息？`,
    c21: `当您使用服务时，我们会从您那里收集以下类型的数据：`,
    c22: `（i） 匿名信息：我们收集有关您使用服务的匿名信息有三个原因：第一，允许我们提供服务并不断改进；第二，出于安全原因；第三，这样我们就可以对使用情况进行统计审计和跟踪，审计我们的附属公司，并计算对第三方的付款。此类匿名信息包括您的大致地理位置、硬件规格、操作系统版本、浏览器类型和版本、软件安装日期、您的URL请求以及相应的时间戳。匿名数据还可能包括任何其他不敏感的、不能识别或可能识别您的数据。`,
    c23: `（ii）个人信息：个人信息是指可能具有私人或敏感性质的信息，可以识别或可能识别您。我们收集和保留的个人信息可能包括您的IP地址、主机名、您的姓名、在您向我们提供这些信息的情况下的电子邮件地址（例如，当您开立帐户或通过“联系我们”选项联系我们时）、屏幕名、，支付和计费信息（如果您购买高级服务）或我们可能不时要求提供的服务所需的其他信息。`,
    t3: `处理的法律依据`,
    c31: `处理用户数据对于履行我们对您的合同义务和向您提供我们的服务、保护我们的合法利益和遵守我们的法律义务是必要的。`,
    c32: `公共数据的处理是根据我们的合法利益进行的，只要这种利益不凌驾于您的基本权利和自由之上。`,
    t4: `我们如何使用您的信息？`,
    c41: `我们使用用户数据是为了向您提供服务，并遵守我们的法律要求和内部准则。这意味着我们将使用这些信息建立您的帐户，为您提供有关服务的支持，与您沟通您可能有的更新、营销优惠或担忧，并进行统计和分析研究以改进服务。我们可能会使用公共数据为用户提供我们的服务。`,
    t5: `我们共享的信息`,
    c51: `我们不会与第三方共享您的个人信息，除非您根据本隐私政策明确同意，或适用法律或法院命令要求。`,
    c52: `如果我们有充分的理由相信有必要：`,
    c53: `（i）遵守法律、法规、传票或法院命令；`,
    c54: `（ii）发现、防止或以其他方式解决欺诈、安全、违反我们的政策或技术问题；`,
    c55: `（iii）执行本隐私政策或您与我们之间的任何其他协议的规定，包括调查潜在的违规行为；`,
    c56: `（iv）保护我们、其合作伙伴、其附属公司、用户或公众的权利、财产或安全免受损害。`,
    t6: `安全和保密`,
    c61: `我们使用行业标准的信息、安全工具和措施，以及内部程序和严格的指导方针，以防止信息滥用和数据泄露。我们的员工和承包商在需要了解的基础上访问信息，并遵守保密义务。`,
    c62: `我们使用的措施和程序大大降低了数据滥用的风险，但我们不能保证我们的系统绝对安全。如果您发现任何潜在的数据泄露或安全漏洞，请立即与我们联系。我们将采取一切措施调查事件，包括必要的预防措施。`,
    t7: `您的选择和权利`,
    c71: `我们重视您的隐私和对个人信息的控制。因此，您可以通知我们您希望查看或删除您的个人信息。您可以发送电子邮件至admin@miyaip.com.您可以随时选择不允许我们或任何第三方收集有关您的数据。您可以请求查看或编辑存储的有关您的个人信息。`,
    c72: `如果您是加利福尼亚州、美国或欧盟的居民，您有权向我们发送一份关于我们可能已向第三方披露或我们可能已提供给第三方的个人信息类别列表的书面请求，以及此类第三方详细信息。若要行使此类权利，您可以通过以下方式与我们联系：admin@miyaip.com`,
    t8: `信息保证免责声明`,
    c81: `尽管本政策中有任何其他规定，我们对我们收集、存储和向您或任何其他人披露的任何信息的准确性、正确性和安全性不负责任。`,
    t9: `联系我们`,
    c91: `如果您觉得您的隐私未按照我们的隐私政策处理，或者您认为您的隐私在使用服务的过程中受到任何人的侵犯，请通过以下方式与我们联系：admin@miyaip.com我们的隐私专员将立即进行调查。`,
    t_1: `介绍`,
    c_11: `写在本网页上的这些网站标准条款和条件将管理您对我们网站的使用，MIYAIP可访问www.miyaip.com。`,
    c_12: `这些条款将完全适用并影响您对本网站的使用。通过使用本网站，您同意接受此处所写的所有条款和条件。如果您不同意本网站的任何标准条款和条件，则不得使用本网站。`,
    c_13: `MIYAIP不会故意从13岁以下的人那里收集个人信息，无论是在线还是离线。如果您未满18岁，只有在父母或监护人的许可下，您才能使用www.miyaip.com。`,
    t_2: `退款政策`,
    c_21: `这些代理从您收到它们时起就处于活动状态。所有代理在交付前都经过测试，交付时完全正常工作。代理根据产品名称和描述指定为数据中心或住宅，不由客户决定。我们不负责在发布期间因使用不当和设置不正确而被禁止。我们保留停用带宽使用过度或超出预期用途（如视频流或文件共享）的代理的权利。请仅在与产品目的相关的网站上使用我们的代理。购买此商品即表示您同意我们的TOS“不退货”政策，因为产品的性质。www.miyaip.com上出售的所有产品都是虚拟的，不能退货。`,
    t_3: `可接受使用政策`,
    c_31: `禁止您使用本网站、其内容和服务： `,
    c_32: `（a） 用于任何非法目的； `,
    c_33: `（b） 教唆他人实施或者参与违法行为；`,
    c_34: `（c） 违反任何国际、联邦、省或州的法规、规则、法律或地方条例；`,
    c_35: `（d） 侵犯或侵犯我们的知识产权或他人的知识产权； `,
    c_36: `（e） 基于性别、性取向、宗教、民族、种族、年龄、民族血统或残疾骚扰、虐待、侮辱、伤害、诽谤、诽谤、贬低、恐吓或歧视；`,
    c_37: `（f） 提交虚假或误导性信息；`,
    c_38: `（g） 上传或传输病毒或任何其他类型的恶意代码，这些代码将以或可能以任何方式使用，从而影响服务或任何相关网站、其他网站或互联网的功能或操作； `,
    c_39: `（h） 收集或跟踪他人的个人信息；`,
    c_310: `（i） 垃圾邮件，钓鱼，制药，借口，蜘蛛，爬行，或刮；`,
    c_311: `（j） 出于任何淫秽或不道德的目的；或（k）干扰或规避服务或任何相关网站、其他网站或互联网的安全功能。我们保留终止您使用本服务或任何相关网站的权利，因为您违反了任何禁止使用的规定，恕不另行通知。`,
    t_4: `知识产权`,
    c_41: `除您拥有的内容外，根据这些条款，MIYAIP和/或其许可方拥有本网站中包含的所有知识产权和材料。`,
    c_42: `您被授予的有限许可仅用于查看本网站上包含的材料。`,
    c_43: `限制`,
    c_44: `您受到以下所有限制：`,
    c_45: `在任何其他媒体上发布www.miyaip.com的任何材料；`,
    c_46: `出售、分许可和/或以其他方式将任何网站材料商业化；`,
    c_47: `公开表演和/或展示任何网站材料；`,
    c_48: `以任何损害或可能损害本网站的方式使用www.miyaip.com；`,
    c_49: `以任何影响用户访问本网站的方式使用www.miyaip.com；`,
    c_410: `违反适用法律法规使用www.miyaip.com，或以任何方式可能对网站、任何个人或商业实体造成损害；`,
    c_411: `从事与本网站有关的任何数据挖掘、数据收集、数据提取或任何其他类似活动；`,
    c_412: `使用本网站从事任何广告或营销活动。`,
    c_413: `本网站的某些区域被限制您访问，MIYAIP可能会在任何时候进一步限制您访问本网站的任何区域。您可能拥有的本网站的任何用户ID和密码都是保密的，您也必须保密。`,
    t_5: `无保证`,
    c_51: `本网站“按原样”提供，不存在任何错误，MIYAIP不表示与本网站或本网站所含材料有关的任何形式的陈述或保证。此外，本网站上的任何内容均不得解释为向您提供建议。`,
    t_6: `责任限制`,
    c_61: `在任何情况下，MIYAIP及其任何高级职员、董事和员工均不对因您使用本网站而产生的或以任何方式与之相关的任何事情承担责任，无论该责任是否根据合同规定。MIYAIP（包括其高级职员、董事和员工）不承担因您使用本网站而产生的或以任何方式与您有关的任何间接、后果性或特殊责任。`,
    t_7: `赔偿`,
    c_71: `您特此最大限度地赔偿MIYAIP因您违反本条款的任何规定而产生的任何和/或所有责任、成本、要求、诉讼理由、损害赔偿和费用。`,
    t_8: `可分割性`,
    c_81: `如果根据任何适用法律，本条款的任何条款被发现无效，则应在不影响本条款其余条款的情况下删除这些条款。`,
    t_9: `条款变更`,
    c_91: `MIYAIP可以在其认为合适的任何时候修改这些条款，通过使用本网站，您可以定期查看这些条款。`,
    t_10: `分配`,
    c_101: `MIYAIP可转让、转让和分包其在本条款下的权利和/或义务，无需任何通知。但是，您不得转让、转让或分包您在本条款下的任何权利和/或义务。`,
    t_11: `完整协议`,
    c_11_1: `本条款构成MIYAIP与您之间关于您使用本网站的完整协议，并取代之前的所有协议和谅解。`,
    t_12: `适用法律和管辖权`,
    c_121: `miyaip.com是BARNETWORK INC的网站，这些条款将受美国法律管辖并根据美国法律进行解释。`,
    t_21: `拒绝服务的权利`,
    c_211: `我们保留拒绝将我们的产品或服务出售给任何个人或实体的权利，根据我们的安全程序和政策，我们认为这些人或实体不适合`,
    t_22: `禁止非法使用`,
    c_221: `禁止所有涉及MIYAIP产品和解决方案的非法活动`,
    t_23: `客户合规性评估`,
    c_231: `如有必要，MIYAIP风险和合规团队将对客户及其用例进行评估`,
    t_24: `某些端口在默认情况下被阻止`,
    c_241: `某些端口默认情况下会被阻止以防止非法活动`,
    t_25: `只有75%的客户获得批准`,
    c_251: `每年至少有四分之一的客户咨询因不符合我们的政策和标准而被拒绝`,
  }
}